import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function sparkTitle(theme: Theme): ComponentStyle {
  return {
    componentName: 'sparkTitle',
    baseStyle: {
      padding: theme.space['xs'],
      background: `linear-gradient(to right, ${theme.colors.spark.purple8}, ${theme.colors.spark.black})`,
      borderRadius: theme.sizes['-2']
    }
  };
}
